import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import Breadcrumb from 'components/app/Breadcrumb'
import PageBody from 'components/app/PageBody'
import OrganizationHeader from 'components/organization/OrganizationHeader'
import TemplatesContainer from 'components/report/templates/TemplatesContainer'

export default function TemplatesPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <Breadcrumb crumbs={[{ label: 'Templates' }]} />
          </Header>
          <OrganizationHeader button={header?.button} />
        </>
      )}
      renderContent={() => <TemplatesContainer />}
    />
  )
}
